import useAppStore from '@store/useAppStore';
import { AxiosResponse } from 'axios';

const useHandleAPICall = () => {
  const { setLoading } = useAppStore();
  const createRequest = async (
    fn: (...props: any) => Promise<AxiosResponse<any, any>>,
    ...props: any[]
  ) => {
    try {
      setLoading(true);
      const response = await fn(...props);
      return response;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };
  return { createRequest };
};

export default useHandleAPICall;
